//@ts-nocheck
import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import MDBox from "components/MDBox";
import DashboardLayout from "lib/LayoutContainers/DashboardLayout";
import withDommer from "pages/withDommer";
import { useStoreActions, useStoreState } from "easy-peasy";
import InnerTable from "lib/Tables/InnerTable";
import Loader from "../../../../components/Loader/Content";
import Card from "@mui/material/Card";
import TransactionsFilterToolbar from "./TransactionTableToolbar";
import StatementsToolbar from "./StatementsToolbar";
import MDTypography from "../../../../components/MDTypography";
import { useParams } from "react-router-dom";
import ExcelExportUtil from "../../../../utils/DataExportUtils";
import PdfExportUtils from "../../../../utils/PdfExportUtils";
import MDDatePicker from "../../../../components/MDDatePicker";
import { get, post } from "../../../../requests";
import MDSnackbar from "../../../../components/MDSnackbar";
import CustomModal from "../../../../components/CustomModal";
import MDInput from "../../../../components/MDInput";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@mui/material";
import FullPageLoader from "components/Loader/FullPage";
import StorageUtils from "utils/StorageUtils";

interface BankStatementTabProps {
  isReadOnly: boolean;
  appId: any;
  focusedAccount?: {
    accountnumber: string;
    monthyear: string;
  };
}

function BankStatementTab({
  focusedAccount,
  appId,
  isReadOnly,
}: BankStatementTabProps): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const dealApplicationId = id || appId;
  const [numberOfDays, setNumberOfDays] = useState(null);
  const fetchBankStatements = useStoreActions(
    (actions) => actions.bankStatements.fetchBankStatements
  );
  const fetchBankAccounts = useStoreActions((actions) => actions.bankStatements.fetchBankAccounts);
  const deleteStatement = useStoreActions((actions) => actions.bankStatements.deleteStatement);
  const bankStatements = useStoreState((state) => state.bankStatements.bankStatements);
  const bankAccounts = useStoreState((state) => state.bankStatements.bankAccounts);
  const columns = useStoreState((state) => state.bankStatements.columns);
  const bankAccountColumns = useStoreState((state) => state.bankStatements.bankAccountColumns);
  const loading = useStoreState((state) => state.bankStatements.loading);
  const accountsLoading = useStoreState((state) => state.bankStatements.accountsLoading);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStatements, setSelectedStatements] = useState<{ label: string; value: string }[]>(
    []
  );
  const [dateFilters, setDateFilters] = useState({ fromDate: null, toDate: null });
  const [loadingIndicator, setLoadingIndicator] = useState(false);

  const [ocrolusLoading, setOcrolusLoading] = useState(false);
  const [ocrolusTransactions, setOcrolusTransactions] = useState<any[]>([]);
  const [ocrolusAccounts, setOcrolusAccounts] = useState<any[]>([]);
  const [availableTags ,setAvailableTags] = useState<any>([])


  const [plaidAccounts, setPlaidAccounts] = useState<any[]>([]);
  const [plaidTransactions, setPlaidTransactions] = useState<any[]>([]);
  const [banks, setBanks] = useState<any[]>([]);
  const [alert, setAlert] = useState<{
    type: "success" | "error" | "warning" | null;
    message: string;
  } | null>(null);
  const [filters, setFilters] = useState<{ debit: boolean; credit: boolean }>({
    debit: true,
    credit: true,
  });
  const [showPlaidTransactionPullPopUp, setShowPlaidTransactionPullPopUp] = useState(false);
  const [selectedAccountForPull, setSelectedAccountForPull] = useState(null);
  const [partyId, setPartyId] = useState<string | null>(null);
  const [ocrAccounts, setOcrAccounts] = useState<any[]>([]);
  const [ocrTransactions, setOcrTransactions] = useState<any[]>([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const ocrAccountsRef = useRef<any[]>([]);
  const plaidTransactionsRef = useRef<any[]>([]);
  const [showOcrTransactionsModal, setShowOcrTransactionsModal] = useState(false);
  const [selectedAccountsForOcr, setSelectedAccountsForOcr] = useState<any[]>([]);
  const [hasSelectedAccounts, setHasSelectedAccounts] = useState(false);
  const [plaidBanks, setPlaidBanks] = useState<any[]>([]);
  const [plaidApiError, setPlaidApiError] = useState<{ accountId: string; message: string } | null>(
    null
  );
  const [flinksBanks, setFlinksBanks] = useState<any[]>([]);
  const [flinksAccounts, setFlinksAccounts] = useState<any[]>([]);
  const [flinksTransactions, setFlinksTransactions] = useState<any[]>([]);
  const [flinksApiError, setFlinksApiError] = useState<{
    accountId: string;
    message: string;
    entityType: string;
  } | null>(null);
  



  useEffect(()=>{
    fetchTags()
  },[])


  useEffect(() => {
    if (id) {
      const loadApplicationData = async () => {
        await getApplicationDetails(id);
      };
      loadApplicationData();
      fetchBankAccounts(id);
      fetchBankStatements(id);
      getOcrAccounts(id);
      getOcrolusTransactions(Number(id));
    }
  }, [id]);

  useEffect(() => {
    console.log("=== Load Flinks Banks ===");
    console.log("  dealApplicationId for flinks:", dealApplicationId);

    if (dealApplicationId) {
      loadFlinksBanksFromServer(dealApplicationId);
    }
  }, [dealApplicationId]);

  useEffect(() => {
    console.log("=== Load Plaid Banks ===");
    console.log("  partyId:", partyId);

    if (partyId) {
      loadPlaidBanksFromServer(partyId);
    }
  }, [partyId]);

  useEffect(() => {
    plaidTransactionsRef.current = plaidTransactions;
  }, [plaidTransactions]);

  const refreshAll = async (refreshId?: any) => {
    const appIdToUse = refreshId || dealApplicationId;
    if (partyId && appIdToUse) {
      await loadPlaidBanksFromServer(partyId);
      await loadFlinksBanksFromServer(appIdToUse);
    } else if (appIdToUse) {
      // If no partyId yet, fetch it from API
      const response = await get(`getDealApplication/${appIdToUse}`);
      if (response) {
        await loadPlaidBanksFromServer(response.partyId);
        await loadFlinksBanksFromServer(response.id);
      }
    }
    await getOcrAccounts(id);
    fetchBankAccounts(id);
    fetchBankStatements(id);
    getOcrolusTransactions(Number(id))
  };

  useEffect(() => {
    const selected = [];
    if (bankAccounts.length > 0) {
      bankAccounts.forEach((account) => {
        selected.push({
          label: `${account.accountnumber} - ${account.monthyear}`,
          value: account.statementid,
        });
      });
    }

    if (plaidAccounts.length > 0) {
      plaidAccounts.forEach((account) => {
        const [month, year] = account.monthYear.split(" ");
        const monthNum = new Date(`${month} 1, ${year}`).getMonth() + 1;
        const formattedMonth = String(monthNum).padStart(2, "0");

        selected.push({
          label: `${account.accountName} -${account.accountNumber || account.mask}`,
          //value: `${year}-${formattedMonth}::${account.accountId}`
          value: account.accountId,
        });
      });
    }

    if (flinksAccounts.length > 0) {
      flinksAccounts.forEach((account) => {
        selected.push({
          label: `${account.accountName} - ${account.mask || account.accountNumber}`,
          value: account.accountId,
        });
      });
    }

    if (ocrAccounts.length > 0) {
      ocrAccounts.forEach((account) => {
        selected.push({
          label: `${account.accountnumber} - ${account.monthyear}`,
          value: account.statementid,
        });
      });
    }

    if (ocrolusAccounts.length > 0) {
      ocrolusAccounts.forEach((account) => {
        selected.push({
          label: `${account.accountnumber} - ${account.monthyear}`,
          value: account.statementid,
        });
      });
    }

    setSelectedStatements(selected);
  }, [bankAccounts, plaidAccounts,flinksAccounts, ocrAccounts, ocrolusAccounts]);

  const refreshFlinksData = useCallback(async () => {
    console.log("=== Refreshing Flinks Data After Delete ===");
    if (dealApplicationId) {
      await loadFlinksBanksFromServer(dealApplicationId);
    }
  }, [dealApplicationId]);

  const handleDateChange = (key: "fromDate" | "toDate", value: Date | null) => {
    setDateFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>, filterType: string) => {
    const newFilters = { ...filters, [filterType]: event.target.checked };
    setFilters(newFilters);
  };

  const mergedBankAccounts = useMemo(() => {
    const formattedPlaidAccounts = plaidAccounts
      .map((account) => {
        if (account.accountId) {
          return {
            statementid: account.accountId,
            accountname: account.bankName,
            accountnumber: `${account.accountName} -${
              account.accountNumber ? account.accountNumber : account.mask
            }`,
            monthyear: account.monthYear,
            source: "Plaid",
            bankId: account.bankId,
            accessToken: account.accessToken,
            createdat: account.createdAt,
          };
        }
        return null;
      })
      .filter((account) => account !== null);

    const formattedFlinksAccounts = flinksAccounts
      .map((account) => {
        if (account.accountId) {
          return {
            statementid: account.accountId,
            accountname: account.bankName,
            accountnumber: `${account.accountName} - ${account.mask || account.accountNumber}`,
            monthyear: account.monthYear,
            source: "Flinks",
            bankId: account.bankId,
            loginId: account.loginId,
            createdat: account.createdAt,
          };
        }
        return null;
      })
      .filter((account) => account !== null);

    ocrAccounts.forEach((account) => {
      account.source = "OCR";
    });

    const combinedAccounts = [
      ...bankAccounts.map((acc) => ({ ...acc, source: "Moneythumb" })),
      ...formattedPlaidAccounts,
      ...formattedFlinksAccounts,
      ...ocrAccounts,
      ...ocrolusAccounts
    ];
    console.log("Combined accounts:", combinedAccounts);
    return combinedAccounts.sort((a, b) => {
      if (!a.createdat && b.createdat) {
        return 1;
      } else if (a.createdat && !b.createdat) {
        return -1;
      } else if (!a.createdat && !b.createdat) {
        return 0;
      }
      const dateA = new Date(a.createdat);
      const dateB = new Date(b.createdat);
      return dateB - dateA;
    });
  }, [bankAccounts, plaidAccounts, ocrAccounts, ocrolusAccounts]);

  const handleOcrAccountSelect = useCallback((account: any) => {
    setSelectedAccountsForOcr((prev) => {
      const newSelection = prev.some((a) => a.statementid === account.statementid)
        ? prev.filter((a) => a.statementid !== account.statementid)
        : [...prev, account];
      setHasSelectedAccounts(newSelection.length > 0);
      return newSelection;
    });
  }, []);

  const renderOcrAccountSelection = useCallback(() => {
    return (
      <MDBox
        sx={{
          maxHeight: "400px",
          overflow: "auto",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
        }}
      >
        <Table
          sx={{
            minWidth: 650,
            "& .MuiTableCell-root": {
              padding: "12px 16px",
              "&:first-of-type": {
                padding: "12px 0 12px 16px",
                width: "50px",
              },
            },
          }}
        >
          <TableHead
            sx={{
              backgroundColor: "background.paper",
              position: "sticky",
              top: 0,
              borderBottom: "2px solid #e0e0e0",
              display: "table-header-group",
              textAlign: "left",
            }}
          >
            <TableRow>
              <TableCell></TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  minWidth: "200px",
                  pl: 1,
                }}
              >
                Account Number
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  minWidth: "150px",
                }}
              >
                Bank Name
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  minWidth: "120px",
                }}
              >
                Month
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  minWidth: "120px",
                }}
              >
                Source
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mergedBankAccounts.map((account) => (
              <TableRow
                key={account.statementid}
                hover
                sx={{
                  backgroundColor: "inherit",
                }}
              >
                <TableCell>
                  <Checkbox
                    checked={selectedAccountsForOcr.some(
                      (a) => a.statementid === account.statementid
                    )}
                    onChange={() => handleOcrAccountSelect(account)}
                    sx={{
                      p: 0,
                      "& .MuiSvgIcon-root": { fontSize: 20 },
                      "&.Mui-disabled": { opacity: 0.5 },
                    }}
                  />
                </TableCell>
                <TableCell sx={{ fontFamily: "monospace", pl: 1, ml: 5 }}>
                  {account.accountnumber}
                </TableCell>
                <TableCell>{account.accountname}</TableCell>
                <TableCell>{account.monthyear}</TableCell>
                <TableCell>{account.source}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </MDBox>
    );
  }, [mergedBankAccounts, selectedAccountsForOcr]);

  useEffect(() => {
    if (focusedAccount && mergedBankAccounts.length > 0) {
      let targetAccount = mergedBankAccounts.find(
        (acc) =>
          acc.accountnumber === focusedAccount.accountnumber &&
          acc.monthyear.includes(focusedAccount.monthyear)
      );

      if (!targetAccount) {
        targetAccount = mergedBankAccounts.find((acc) => {
          // Extract last 4 digits for MoneyThumb accounts
          const last4Search = focusedAccount.accountnumber.slice(-4);
          const last4Account = acc.accountnumber.slice(-4);
          return (
            last4Account === last4Search &&
            acc.monthyear.includes(focusedAccount.monthyear) &&
            (acc.source === "Moneythumb" || acc.source === "OCR")
          );
        });
      }

      if (targetAccount) {
        setSelectedStatements([
          {
            label: `${targetAccount.accountnumber} - ${targetAccount.monthyear}`,
            value: targetAccount.statementid,
          },
        ]);
      } else {
        console.warn("Account not found", {
          searchedAccount: focusedAccount.accountnumber,
          searchedMonth: focusedAccount.monthyear,
          availableAccounts: mergedBankAccounts.map((a) => ({
            account: a.accountnumber,
            month: a.monthyear,
            source: a.source,
          })),
        });
      }
    } else if (!isInitialLoad) {
      setSelectedStatements([]);
    }
  }, [focusedAccount, mergedBankAccounts]);

  const handleRunOcrTransactions = useCallback(async () => {
    if (selectedAccountsForOcr.length === 0) {
      setAlert({ type: "error", message: "Please select at least one account" });
      return;
    }
    setLoadingIndicator(true);
    try {
      const payload = {
        appId: Number(id),
        accounts: selectedAccountsForOcr.map((account) => {
          const moneyThumbTransactions = bankStatements
            .filter((txn) => txn.statementId === account.statementid)
            .map((txn) => ({
              description: txn.description,
              memo: txn.memo || "",
              checkNumber: txn.checkNumber || null,
              txnDate: txn.txnDate,
              amount: txn.amount,
              runningBalance: null,
              type: txn.type.toLowerCase(),
              source: "MoneyThumb",
              trueval: txn.trueval !== false,
            }));

          const plaidTransactionsForAccount = plaidTransactionsRef.current.map((txn) => ({
            description: txn.name,
            memo: txn.category ? txn.category.replace(/[\[\]]/g, "") : "",
            checkNumber: null,
            txnDate: txn.transactionDate,
            amount: Math.abs(txn.amount),
            runningBalance: null,
            type: txn.amount > 0 ? "credit" : "debit",
            source: "Plaid",
            trueval: txn.trueval,
          }));

          // 3. OCR Transactions
          const ocrTransactionsForAccount = ocrTransactions
            .filter((txn) => txn.statementId === account.statementid)
            .map((txn) => ({
              description: txn.description,
              memo: txn.memo || "",
              source: "OCR",
              checkNumber: txn.checkNumber || null,
              txnDate: txn.txnDate,
              amount: txn.amount,
              runningBalance: txn.runningBalance,
              type: txn.type.toLowerCase(),
              trueval: txn.trueval !== false,
            }));

          const allTransactions = [
            ...moneyThumbTransactions,
            ...plaidTransactionsForAccount,
            ...ocrTransactionsForAccount,
          ];

          return {
            accountNumber: account.accountnumber,
            statementId: account.statementid,
            transactions: allTransactions,
          };
        }),
      };
      const response = await post("ocr/processTransactions", payload);
      setAlert({
        type: "success",
        message: 'OCR processing started. Please "REFRESH" later to see results.',
      });
      await getOcrAccounts(id);
      fetchBankStatements(id);
    } catch (error) {
      console.error("OCR Processing Error:", error);
      setAlert({ type: "error", message: "Failed to process transactions" });
    } finally {
      setLoadingIndicator(false);
      setShowOcrTransactionsModal(false);
    }
  }, [selectedAccountsForOcr, id, ocrTransactions, bankStatements, bankAccounts]);

  const mapPlaidToBankStatement = (plaidTransaction) => {
    const amount = plaidTransaction.amount;
    const transactionType = amount > 0 ? "debit" : "credit";
    const category = plaidTransaction.category
      ? plaidTransaction.category.replace(/[\[\]]/g, "")
      : "";
    const txnDate = new Date(plaidTransaction.transactionDate);
    const yearMonth = txnDate.getFullYear() + "-" + String(txnDate.getMonth() + 1).padStart(2, "0");

    return {
      accountName: plaidTransaction.bankName,
      accountNumber: plaidTransaction.accountName,
      amount: Math.abs(amount),
      applicationId: id,
      checkNumber: 0,
      description: plaidTransaction.name,
      id: plaidTransaction.id,
      isDataModified: false,
      memo: category,
      possible: false,
      statementId: `${yearMonth}::${plaidTransaction.transactionAccountId}`,
      trueval: plaidTransaction.trueval,
      txnDate: plaidTransaction.transactionDate,
      txnId: plaidTransaction.transactionId,
      type: transactionType,
      source: "Plaid",
    };
  };

  const mergedBankStatements = useMemo(() => {
    const mappedPlaidTransactions = plaidTransactions.map(mapPlaidToBankStatement);
    const mappedFlinksTransactions = flinksTransactions.map((flinksTransaction) => {
      const txnDate = new Date(flinksTransaction.transactionDate);
      const yearMonth =
        txnDate.getFullYear() + "-" + String(txnDate.getMonth() + 1).padStart(2, "0");

      // Find the account for this transaction to get bank name and account name
      const account = flinksAccounts.find(
        (acc) =>
          acc.originalAccountId === flinksTransaction.transactionAccountId ||
          acc.accountId === flinksTransaction.transactionAccountId ||
          (acc.accountId && acc.accountId.includes(flinksTransaction.transactionAccountId))
      );

      return {
        accountName: account?.bankName || "Unknown",
        accountNumber: account?.accountName || "",
        amount: Math.abs(flinksTransaction.amount),
        applicationId: id,
        checkNumber: 0,
        description: flinksTransaction.name,
        id: flinksTransaction.id,
        isDataModified: false,
        memo: flinksTransaction.category || "",
        possible: false,
        statementId: `${yearMonth}::${flinksTransaction.transactionAccountId}`,
        trueval: flinksTransaction.trueval !== false, // Default to true
        txnDate: flinksTransaction.transactionDate,
        txnId: flinksTransaction.transactionId,
        type: flinksTransaction.type,
        source: "Flinks",
      };
    });
    console.log("mappedFlinksTransactions:", mappedFlinksTransactions.length);

    const allTransactions = [
      ...bankStatements,
      ...mappedPlaidTransactions,
      ...mappedFlinksTransactions,
      ...ocrTransactions,
      ...ocrolusTransactions
    ];

    console.log("allTransactions before sort:", allTransactions.length);

    return allTransactions.sort((a, b) => {
      const dateA = new Date(a.txnDate);
      const dateB = new Date(b.txnDate);

      if (dateA.getTime() !== dateB.getTime()) {
        return dateA - dateB;
      }

      const createdAtA = a.createdAt ? new Date(a.createdAt) : new Date(0);
      const createdAtB = b.createdAt ? new Date(b.createdAt) : new Date(0);

      if (createdAtA.getTime() !== createdAtB.getTime()) {
        return createdAtA - createdAtB;
      }

      const descA = a.description?.toLowerCase() || "";
      const descB = b.description?.toLowerCase() || "";

      return descA.localeCompare(descB);
    });
  }, [bankStatements, plaidTransactions, flinksTransactions, ocrTransactions,ocrolusTransactions]);


  const filteredBankStatements = useMemo(() => {
    const filtered = mergedBankStatements
      .filter((statement) => {
        const matches = selectedStatements.some((selected) => {
          const selectedVal = selected.value;
          const statementVal = statement.statementId;

          const isSelectedString = typeof selectedVal === "string";
          const isStatementString = typeof statementVal === "string";

          const selectedAccountId =
            isSelectedString && selectedVal.includes("::")
              ? selectedVal.split("::").pop()
              : selectedVal;

          const statementAccountId =
            isStatementString && statementVal.includes("::")
              ? statementVal.split("::").pop()
              : statementVal;

          const match = selectedVal === statementVal || selectedAccountId === statementAccountId;
          return match;
        });
        return matches;
      })
      .filter((statement) => {
        if (filters.debit && filters.credit) return true;
        if (filters.debit && statement.type?.toLowerCase() === "debit") return true;
        if (filters.credit && statement.type?.toLowerCase() === "credit") return true;
        return false;
      })
      .filter((statement) => {
        const transactionDate = new Date(statement.txnDate);
        if (dateFilters.fromDate && transactionDate < new Date(dateFilters.fromDate)) return false;
        if (dateFilters.toDate && transactionDate > new Date(dateFilters.toDate)) return false;
        return true;
      });
    return filtered;
  }, [mergedBankStatements, selectedStatements, filters, dateFilters]);

  const loadPlaidBanksFromServer = async (merchantId: any) => {
    setLoadingIndicator(true);
    const tenantId = localStorage.getItem("tenantId");

    try {
      const banks = await post("fetchBanksByTenantAndParty", {
        tenantId,
        fetchMerchantBank: true,
        partyId: merchantId,
      });
      setBanks(banks);
      setPlaidBanks(banks);
      setLoadingIndicator(false);
      console.log("banks response for access token", banks[0]?.accessToken);
      if (banks.length > 0) await getPlaidAccounts(banks);
      else {
        setPlaidAccounts([]);
        setPlaidTransactions([]);
      }
    } catch (error) {
      console.error("Error loading banks:", error);
      setLoadingIndicator(false);
      setAlert({ type: "error", message: "Error loading banks from server." });
    }
  };

  const loadFlinksBanksFromServer = async (applicationId: any) => {
    setLoadingIndicator(true);
    const tenantId = localStorage.getItem("tenantId");

    try {
      const response = await post("flinksService/fetchFlinksBanksByTenantAndParty", {
        tenantId,
        // fetchMerchantBank: true,
        dealApplicationId: applicationId,
        //   partyId: merchantId,
      });

      const banks = response.data || response;
      console.log("Flinks banks response:", response);
      console.log("Banks data:", banks);
      setFlinksBanks(banks);
      setLoadingIndicator(false);

      console.log("Banks length:", banks.length);

      if (banks.length > 0) {
        console.log("Calling getFlinksAccounts with banks:", banks);
        await getFlinksAccounts(banks);
      } else {
        console.log("No banks, clearing accounts and transactions");
        setFlinksAccounts([]);
        setFlinksTransactions([]);
      }
    } catch (error: any) {
      console.error("Error loading Flinks banks:", error);
      setFlinksBanks([]);
      setFlinksAccounts([]);
      setFlinksTransactions([]);
    } finally {
      setLoadingIndicator(false);
    }
  };

  const getFlinksAccounts = async (banks: any[]) => {
    console.log("=== getFlinksAccounts called ===");
    console.log("Banks:", banks);

    const bankIds = banks?.map((bank) => bank.id);
    console.log("Bank IDs:", bankIds);

    if (bankIds.length > 0) {
      setLoadingIndicator(true);
      try {
        const uniqueBankIds = [...new Set(bankIds)];
        console.log("Calling accounts API with bankIds:", uniqueBankIds);

        const response = await get(
          `/flinksService/flinks/accounts/getAllAccountsForMonth?bankIds=${uniqueBankIds.join(",")}`
        );

        console.log("Accounts API RAW response:", response);
        console.log("response.data:", response.data);

        const accounts = response.data;
        console.log("Extracted accounts:", accounts);
        console.log("Accounts length:", accounts?.length);

        setLoadingIndicator(false);

        if (accounts) {
          accounts.forEach((acc) => (acc.isChecked = true));
        }
        console.log("Setting flinksAccounts:", accounts);
        setFlinksAccounts(accounts || []);

        if (accounts && accounts.length > 0) {
          console.log("Calling getFlinksTransactions");
          await getFlinksTransactions(accounts);
        } else {
          console.log("No accounts, clearing transactions");
          setFlinksTransactions([]);
        }
      } catch (error) {
        console.error("Error fetching Flinks accounts:", error);
        setLoadingIndicator(false);
        setAlert({ type: "error", message: "Error fetching Flinks accounts." });
      }
    } else {
      console.log("No bank IDs");
      setFlinksAccounts([]);
      setFlinksTransactions([]);
      setLoadingIndicator(false);
    }
  };

  const getFlinksTransactions = async (accounts: any[]) => {
    setLoadingIndicator(true);
    const accountIds = accounts.filter((account) => account.isChecked).map((account) => account.id);

    console.log("Filtered account IDs:", accountIds);

    if (accountIds.length > 0) {
      try {
        const uniqueAccountIds = [...new Set(accountIds)];
        console.log("Calling transactions API with IDs:", uniqueAccountIds);

        const response = await get(
          `flinksService/flinks/transactions/byAccountIds/${uniqueAccountIds.join(",")}`
        );

        console.log("Transactions API response:", response);

        const transactions = response.data;
        console.log("Extracted transactions:", transactions);
        console.log("Transaction count:", transactions?.length);

        let transactionsWithSource = [];
        if (transactions) {
          transactionsWithSource = transactions.map((transaction: any) => ({
            ...transaction,
            source: "Flinks",
          }));
        }

        console.log("Setting flinksTransactions:", transactionsWithSource);
        setFlinksTransactions(transactionsWithSource);
        setLoadingIndicator(false);
      } catch (error) {
        console.error("Error fetching Flinks transactions:", error);
        setAlert({ type: "error", message: "Error fetching Flinks transactions" });
        setLoadingIndicator(false);
      }
    } else {
      console.log("No account IDs to fetch");
      setFlinksTransactions([]);
      setLoadingIndicator(false);
    }
  };

  const getApplicationDetails = async (applicationId: any) => {
    try {
      const response = await get(`getDealApplication/${applicationId}`);
      if (response && response.partyId) {
        setPartyId(response.partyId);
      }
    } catch (error) {
      console.error("Error fetching application details:", error);
    }
  };

  const getPlaidAccounts = async (banks: any[]) => {
    const bankIds = banks?.map((bank) => bank.id);
    if (bankIds.length > 0) {
      setLoadingIndicator(true);
      try {
        const uniqueBankIds = [...new Set(bankIds)];
        const accounts = await get(
          `/accounts/getAllAccountsForMonth?bankIds=${uniqueBankIds.join(",")}`
        );
        setLoadingIndicator(false);
        if (accounts) accounts.forEach((acc) => (acc.isChecked = true));
        setPlaidAccounts(accounts || []);

        if (accounts.length > 0) getPlaidTransactions(accounts);
        else setPlaidTransactions([]);
      } catch (error) {
        console.error("Error fetching accounts:", error);
        setLoadingIndicator(false);
        setAlert({ type: "error", message: "Error fetching accounts." });
      }
    } else {
      setPlaidAccounts([]);
      setPlaidTransactions([]);
      setLoadingIndicator(false);
    }
  };

  const findPeriodForTxn = (bankAccount: any, txnDateStr: string) => {
    if (!bankAccount?.periods || !txnDateStr) return null;

    const txnDate = new Date(txnDateStr);
    txnDate.setHours(0, 0, 0, 0);

    return bankAccount.periods.find((period: any) => {
      if (!period.begin_date || !period.end_date) return false;

      const [bm, bd, by] = period.begin_date.split("/").map(Number);
      const [em, ed, ey] = period.end_date.split("/").map(Number);

      const begin = new Date(by, bm - 1, bd);
      begin.setHours(0, 0, 0, 0);

      const end = new Date(ey, em - 1, ed);
      end.setHours(23, 59, 59, 999);

      return txnDate >= begin && txnDate <= end;
    });
  };

  const getOcrAccounts = async (appId) => {
    if (!appId) {
      setAlert({ type: "error", message: "Invalid request with missing appId" });
      return;
    }
    setLoadingIndicator(true);
    try {
      const response = await get(`ocr/getAccounts/${appId}`);

      if (response && response.length > 0) {
        response.forEach((account) => (account.isChecked = true));
        setOcrAccounts(response);

        await getOcrTransactions(appId);
      } else {
        setOcrAccounts([]);
        setOcrTransactions([]);
        ocrAccountsRef.current = [];
      }
      setLoadingIndicator(false);
    } catch (error) {
      console.error("Error fetching OCR accounts:", error);
      setLoadingIndicator(false);
      setAlert({ type: "error", message: "Error fetching OCR accounts." });
    }
  };

  const buildOcrolusAccountsFromBankAccounts = (bankAccountsMap: any) => {
    const accounts: any[] = [];

    Object.values(bankAccountsMap || {}).forEach((bankAccount: any) => {
      const {
        pk,
        bank_name,
        account_number,
        account_type,
        periods = [],
      } = bankAccount;

      periods.forEach((period: any) => {
        if (!period.begin_date) return;
        const [month, day, year] = period.begin_date.split("/").map(Number);
        const startDate = new Date(year, month - 1, day);

        const monthyear = startDate.toLocaleString("default", {
          month: "long",
          year: "numeric",
        });

        accounts.push({
          statementid: period.pk,
          accountnumber: account_number,
          accountname: `${bank_name} ${account_type}`,
          monthyear,
          source: "Ocrolus",
          bank_account_pk: pk,
          period_pk: period.pk,
          period_uuid: period.uuid,
          createdat: startDate.toISOString(),
        });
      });
    });

    return accounts;
  };

  const deriveOcrolusTrueval = (txn: any): boolean => {
    return txn.revenue === true;
  };

 const fetchTags = async () => {
    try {
      if(!StorageUtils.isFeatureEnabled("ocrolus")){
        return;
     }
      const res = await get("integration/ocrolous/tags");
      if (res?.status === "success") {
        setAvailableTags(res.data || []);
      }
    } catch {
      setAvailableTags([]);
    }
  };

  const getOcrolusTransactions = async (appId: number) => {
    if (!appId) return;

    if(!StorageUtils.isFeatureEnabled("ocrolus")){
       return;
    }

    try {
      setOcrolusLoading(true);
      const res = await get(`integration/ocrolous/transactions/${appId}`);

      if (res?.status !== "success") {
        setOcrolusTransactions([]);
        setOcrolusAccounts([]);
        return;
      }

      const txns = res?.data?.transactions || {};
      const enrichedTxns = txns.enriched_transactions || [];
      const bankAccountsMap = txns.bank_accounts || {};

      const normalizedTxns = [];
      const usedPeriods = new Set<number>();

      enrichedTxns.forEach((txn: any) => {
        const bankAccount = bankAccountsMap[txn.bank_account_pk];
        if (!bankAccount) return;

        const period = findPeriodForTxn(bankAccount, txn.txn_date);
        if (!period) return;

        usedPeriods.add(period.pk);

        normalizedTxns.push({
          txn_pk: txn.txn_pk,
          statementId: period.pk,
          txnDate: txn.txn_date,
          description: txn.description,
          memo: txn.comment || "",
          amount: txn.amount,
          type: txn.amount >= 0 ? "credit" : "debit",
          runningBalance: txn.running_balance ?? null,
          trueval: txn.revenue === true,
          source: "Ocrolus",
          createdAt: txn.created_at,
          accountNumber: bankAccount.account_number,
          accountName: bankAccount.bank_name,

        });
      });

      const ocrolusAccounts = buildOcrolusAccountsFromBankAccounts(bankAccountsMap)
        .filter((acc) => usedPeriods.has(acc.period_pk));

      setOcrolusTransactions(normalizedTxns);
      setOcrolusAccounts(ocrolusAccounts);
    } catch (error) {
      console.error("Error fetching Ocrolus transactions:", error);
      setAlert({
        type: "error",
        message: "Failed to fetch Ocrolus transactions",
      });
    } finally {
      setOcrolusLoading(false);

    }
  };




  const handleCheckboxChange = async (row: any, columnId: string, value: boolean, tags) => {
    try {
      setLoadingIndicator(true);

      const txn = row.original;
      if (txn.source === "Ocrolus") {
        const revenueTag = tags.find(
          (t: any) => t.name?.toLowerCase() === "revenue"
        );

        if (!revenueTag) {
          setAlert({ type: "error", message: "Revenue tag not found" });
          return;
        }


        let payload;
        if (value) {
            payload = {
               txns: [{
                     txn_pk: txn.txn_pk,
                     tags: [{
                      tag_uuid : revenueTag.uuid,
                      apply_to_txn: true
                     }]
                     }],
                   }
         } else {

          payload = {
            txns: [{
                  txn_pk: txn.txn_pk,
                  tags: [{
                   tag_uuid : revenueTag.uuid,
                   apply_to_txn: false
                  }]
                  }],
                }
        }

        await post(
          `/integration/ocrolous/transactions/${id}/tags`,
          payload
        );
      }
      else {
        const request = {
          ...txn,
          trueval: value,
        };

        const result = await post("bankStatements/updateTransaction", request);

        if (!result?.success) {
          throw new Error("Update failed");
        }
      }

      await refreshAll(id);
      setAlert({ type: "success", message: "Successfully Updated Transaction" });
    } catch (error) {
      console.error(error);
      setAlert({ type: "error", message: "Failed to Update Transaction" });
    } finally {
      setLoadingIndicator(false);
    }
  };


  const columnsWithCheckbox = useMemo(() => {
    if (!columns) return [];

    return columns.map((col) => {
      if (col.accessor === "trueval") {
        return {
          ...col,
          Cell: ({ row, value }: any) => {
            console.log("trueval:", value);
            return (
              <Checkbox
                checked={value === true}
                onChange={(e) => handleCheckboxChange(row, "trueval", e.target.checked,availableTags)}
              />
            );
          },
        };
      }
      return col;
    });
  }, [columns, availableTags]);

  const getOcrTransactions = async (appId: number) => {
    setLoadingIndicator(true);

    try {
      const response = await get(`ocr/getTransactions/${appId}`);
      let transactionsWithSource = [];
      if (response) {
        transactionsWithSource = response?.map((transaction: any) => ({
          ...transaction,
          source: "OCR",
        }));
      }
      setOcrTransactions(transactionsWithSource || []);
      setLoadingIndicator(false);
    } catch (error) {
      console.error("Error fetching OCR transactions:", error);
      setLoadingIndicator(false);
      setAlert({ type: "error", message: "Error fetching OCR transactions." });
    }
  };

  const getPlaidTransactions = async (accounts: any[]) => {
    setLoadingIndicator(true);
    const accountIds = accounts.filter((account) => account.isChecked).map((account) => account.id);
    if (accountIds.length > 0) {
      try {
        const uniqueAccountIds = [...new Set(accountIds)];
        const response = await get(
          `fetchTransactionsByAccountNumbers/${uniqueAccountIds.join(",")}`
        );

        let transactionsWithSource = [];
        if (response) {
          transactionsWithSource = response.map((transaction: any) => ({
            ...transaction,
            source: "Plaid",
          }));
        }
        setPlaidTransactions(transactionsWithSource);
        setLoadingIndicator(false);
      } catch (error) {
        console.error("Error fetching transactions:", error);
        setAlert({ type: "error", message: "Error fetching transactions" });
        setLoadingIndicator(false);
      }
      setLoadingIndicator(false);
    } else {
      setPlaidTransactions([]);
      setLoadingIndicator(false);
    }
  };

  const handleSelectItem = (id: number) => {
    setSelectedStatements((prevSelected) => {
      const account = mergedBankAccounts.find((acc) => acc.statementid === id);
      if (!account) return prevSelected;

      const selectedIndex = prevSelected.findIndex((item) => item.value === account.statementid);
      if (selectedIndex > -1) {
        return prevSelected.filter((item) => item.value !== account.statementid);
      } else {
        return [
          ...prevSelected,
          { label: `${account.accountnumber} - ${account.monthyear}`, value: account.statementid },
        ];
      }
    });
  };

  const handleExport = (rows: any[], format?: "excel" | "pdf") => {
    const processedRows = rows.map((row) => {
      const originalRow = row.original;
      const processedRow = {
        ...originalRow,
        trueval: originalRow.trueval === true,
        checkbox: true,
        txnDate: originalRow.txnDate ? ExcelExportUtil.formatCsvDate(originalRow.txnDate) : "",
      };
      return processedRow;
    });

    const now = new Date();
    const formattedDate = now.toISOString().replace(/[:.-]/g, "");
    const updatedColumns = [
      ...columns.filter((col) => col.Header !== "Use"),
      { Header: "Use", accessor: "checkbox" },
    ];

    if (format === "pdf") {
      const fileName = `transactions_${formattedDate}.pdf`;
      PdfExportUtils.exportToPdf(updatedColumns, processedRows, "Transactions", fileName);
    } else {
      const fileName = `transactions_${formattedDate}.xlsx`;
      ExcelExportUtil.exportToExcel(updatedColumns, processedRows, "transactions", fileName);
    }
  };

  const handleDeleteStatement = async (statementId: number, source: string, bankId?: number) => {
    try {
      await deleteStatement({
        statementId,
        appId: dealApplicationId,
        source,
        bankId,
        setPlaidAccounts,
        setPlaidTransactions,
        setFlinksAccounts,
        setFlinksTransactions,
        setOcrAccounts,
        setOcrTransactions,
        setAlert,
        refreshFlinksData,
      });
    } catch (error) {
      console.error("Failed to delete statement:", error);
    }
  };

  const setPlaidTransactionPullPopUp = (value: boolean, account: any) => {
    setShowPlaidTransactionPullPopUp(value);
    setSelectedAccountForPull(account);
  };

  const handleNumberOfDaysChange = (event) => {
    setNumberOfDays(event.target.value);
  };

  const handleAllSelection = (value: boolean) => {
    console.log("All selected", value);
  };

  const selectAllRows = (value: boolean) => {
    if (value) {
      const selected = [];
      if (bankAccounts.length > 0) {
        bankAccounts.forEach((account) => {
          selected.push({
            label: `${account.accountnumber} - ${account.monthyear}`,
            value: account.statementid,
          });
        });
      }

      if (plaidAccounts.length > 0) {
        plaidAccounts.forEach((account) => {
          selected.push({
            label: `${account.accountName} -${
              account.accountNumber ? account.accountNumber : account.mask
            }`,
            value: account.accountId,
          });
        });
      }

      if (flinksAccounts.length > 0) {
        console.log("flinks accounts", flinksAccounts);
        flinksAccounts.forEach((account) => {
          selected.push({
            label: `${account.accountName} - ${account.mask || account.accountNumber}`,
            value: account.accountId,
          });
        });
      }

      if (ocrAccounts.length > 0) {
        ocrAccounts.forEach((account) => {
          selected.push({
            label: `${account.accountnumber} - ${account.monthyear}`,
            value: account.statementid,
          });
        });
      }
      setSelectedStatements(selected);
    } else {
      setSelectedStatements([]);
    }
  };

  const handleSubmitAccountPull = async () => {
    if (!numberOfDays || isNaN(numberOfDays) || Number(numberOfDays) <= 0) {
      setAlert({ type: "error", message: "Please enter a valid number of days." });
      return;
    }

    try {
      setShowPlaidTransactionPullPopUp(false);
      setLoadingIndicator(true);

      // 1. Extract account info safely
      const statementId = selectedAccountForPull?.statementid || "";
      const transactionAccountId = statementId.includes("::")
        ? statementId.split("::")[1]
        : statementId;
      console.log("transactionAccountId selected", transactionAccountId);

      // 2. Find related bank account
      const bankAccount = mergedBankAccounts.find(
        (acc) => acc.statementid === selectedAccountForPull?.statementid
      );
      if (!bankAccount) throw new Error("Bank account not found");
      console.log("bank account selected", bankAccount);

      // 3. Find bank
      const bank = banks.find((b) => b.id === bankAccount.bankId);
      if (!bank) throw new Error("Bank details not found");
      console.log("bank selected", banks);
      console.log("entity type selected", bank.entityType);

      const accessToken =
        bank.entityType === "MERCHANT"
          ? bank.accessToken
          : banks.find((b) => b.entityType === "FUNDER")?.accessToken;
      console.log("access Token selected", accessToken, bank.entityType);
      if (!accessToken) {
        throw new Error("No access token available");
      }

      const params = {
        accessToken,
        itemId: bank.itemId,
        tenantId: Number(localStorage.getItem("tenantId")),
        transactionLimit: numberOfDays.toString(),
        entityType: bank.entityType,
      };

      console.log("Making API call with params:", params);

      try {
        const response = await post(
          `plaidService/fetchNewTransactions/${transactionAccountId}`,
          params
        );

        console.log("response from plaid fetchNewTransactions", response);
        const status = response.status;
        const message = response.message || "";

        console.log("Plaid API response status:", status);
        console.log("Plaid API response message:", message);

        if (status?.toLowerCase() === "success") {
          await loadPlaidBanksFromServer(partyId);
          fetchBankStatements(id);
          fetchBankAccounts(id);
          setPlaidTransactions([]);

          const accounts = await getPlaidAccounts(banks);
          if (accounts?.length) {
            await getPlaidTransactions(accounts);
          }

          setAlert({ type: "success", message: "Transactions refreshed successfully!" });
          return;
        }
        if (status?.toLowerCase() === "failure") {
          handlePlaidFailureResponse(message, transactionAccountId);
          return;
        }

        setAlert({ type: "error", message: message || "Unknown response from server" });
      } catch (error: any) {
        console.log("Axios error caught:", error);
        if (error.response && error.response.data) {
          const responseData = error.response.data;
          console.log("Error response data:", responseData);

          const status = responseData.status;
          const message = responseData.message || "";

          console.log("Plaid API error response:", status, message);

          if (status?.toLowerCase() === "failure") {
            handlePlaidFailureResponse(message, transactionAccountId);
            return;
          }
          setAlert({ type: "error", message: message || "API error occurred" });
          return;
        }
        throw error;
      }
    } catch (error: any) {
      console.error("Unexpected error in handleSubmitAccountPull:", error);
      setAlert({
        type: "error",
        message: error.message || "An unexpected error occurred",
      });
    } finally {
      setLoadingIndicator(false);
      setShowPlaidTransactionPullPopUp(false);
    }
  };

  const handlePlaidFailureResponse = (message: string, accountId: string, entityType: string) => {
    console.log("Plaid API failure returned:", message);
    const needsLogin = message.includes("ITEM_LOGIN_REQUIRED");

    if (needsLogin) {
      console.log("Detected Plaid error that requires re-login:", accountId);

      setPlaidApiError({
        accountId: accountId,
        message: message,
        entityType: entityType,
      });

      setAlert({
        type: "warning",
        message:
          "Looks like login credentials have changed. Please sign in with new login credentials.",
      });
      return;
    }

    setAlert({ type: "error", message: message || "Failed to pull transactions." });
  };

  const handleAccountRefresh = async (bank: any, isPlaidDirect: boolean = true) => {
    setLoadingIndicator(true);
    const bankId = isPlaidDirect ? bank.id : bank.bankId;
    try {
      const tenantId = localStorage.getItem("tenantId");
      let accessToken = bank.accessToken;

      const params = {
        accessToken,
        bankId,
        tenantId,
      };

      const tenantFeatures = await get("getTenantFeatures");
      if (tenantFeatures["bank_account_integration"]) {
        const response = await post("plaidService/refreshAccounts", params);

        if (response && response.success) {
          await loadPlaidBanksFromServer(partyId);
          fetchBankAccounts(id);
          fetchBankStatements(id);
        } else {
          setAlert({
            type: "error",
            message: "Error refreshing accounts.",
          });
        }
      } else {
        setAlert({
          type: "error",
          message: "Bank account feature is not enabled.",
        });
      }
    } catch (error) {
      console.error("Error refreshing bank accounts:", error);
      setAlert({
        type: "error",
        message: "An error occurred while refreshing bank accounts.",
      });
    } finally {
      setLoadingIndicator(false);
    }
  };

  const handleFlinksAccountRefresh = async (account: any) => {
    console.log("=== Refresh Flinks Account ===");

    if (!account.bankId) {
      setAlert({ type: "error", message: "Bank ID not found" });
      return;
    }

    setLoadingIndicator(true);

    try {
      const response = await post(`flinksService/refreshBank`, {
        dealApplicationId: dealApplicationId,
        bankId: account.bankId,
      });

      console.log("Flinks Refresh response:", response);

      if (response.status === "success") {
        if (response.updated === false) {
          // No newer data
          setAlert({
            type: "info",
            message: response.message || "No newer data available",
          });
          setLoadingIndicator(false);
        } else {
          // Updated successfully
          const accountsText =
            response.accountsCount === 1 ? "1 account" : `${response.accountsCount} accounts`;
          const transactionsText =
            response.transactionsCount === 1
              ? "1 transaction"
              : `${response.transactionsCount} transactions`;

          setAlert({
            type: "success",
            message: `Bank refreshed! ${accountsText} updated.`,
          });

          // Reload data
          await loadFlinksBanksFromServer(dealApplicationId);
          setLoadingIndicator(false);
        }
      } else if (response.status === "pending") {
        setAlert({
          type: "warning",
          message: "Data is still processing. Please try again in a moment.",
        });
        setLoadingIndicator(false);
      } else {
        setAlert({
          type: "error",
          message: response.message || "Failed to refresh bank",
        });
        setLoadingIndicator(false);
      }
    } catch (error: any) {
      console.error("Error refreshing Flinks bank:", error);

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to trigger refresh. Please try again.";

      setAlert({
        type: "error",
        message: errorMessage,
      });
      setLoadingIndicator(false);
    }
  };

  const handleClose = () => {
    setShowPlaidTransactionPullPopUp(false);
  };

  const extractTags = (txn) => availableTags.filter((tag) => txn[tag.name] === true);


  const renderAccounts = () => {
    return (
      <InnerTable
        table={{
          columns: bankAccountColumns(
            isReadOnly,
            handleDeleteStatement,
            setPlaidTransactionPullPopUp,
            handleAccountRefresh,
            handleFlinksAccountRefresh,
            handleAllSelection
          ),
          rows: mergedBankAccounts,
        }}
        entriesPerPage={{ defaultValue: 5, entries: ["5", "10", "15", "20"] }}
        paginationEnabled={true}
        canSearch={false}
        selectedItem={selectedStatements.map((account) => account.value)}
        onSelectItem={handleSelectItem}
        getRowId={(row) => row.statementid}
        selectAllRows={selectAllRows}
      />
    );
  };

  const renderTransactions = () => {
    return (
      <InnerTable
        table={{
          columns: columnsWithCheckbox,
          rows: filteredBankStatements,
          searchQuery,
        }}
        entriesPerPage={{ defaultValue: 25, entries: ["25", "50", "75", "100"] }}
        canSearch={true}
        exportExcel={true}
        enableMultiFormatExport={true}
        searchQuery={searchQuery}
        paginationEnabled={true}
        onExport={handleExport}
        hasHeaders={true}
        tableHeaders={
          <MDBox width={"100%"} display={"flex"} justifyContent={"space-between"}>
            <MDTypography variant="h4">Transactions</MDTypography>
          </MDBox>
        }
        hasFilterComponent={true}
        filterComponent={
          <TransactionsFilterToolbar
            dateFilters={dateFilters}
            handleDateChange={handleDateChange}
            onFilterChange={handleFilterChange}
            filters={filters}
          />
        }
        dateFilter={
          <MDBox display="flex" justifyContent="space-between">
            <MDBox display="flex" justifyContent="flex-end" alignItems="flex-start">
              <MDDatePicker
                input={{ placeholder: "Filter From Date" }}
                value={dateFilters.fromDate}
                onChange={(date) => handleDateChange("fromDate", date)}
              />
              <MDBox className={"ml-10"}>
                <MDDatePicker
                  input={{ placeholder: "Filter To Date" }}
                  value={dateFilters.toDate}
                  onChange={(date) => handleDateChange("toDate", date)}
                />
              </MDBox>
            </MDBox>
          </MDBox>
        }
      />
    );
  };

  return (
    <>
      <MDBox mb={3}>
        {(loadingIndicator || accountsLoading || loading || ocrolusLoading) && <FullPageLoader />}
        <Card sx={{ paddingLeft: "2rem", paddingTop: "2rem" }}>
          <MDTypography variant="h4" mb={1}>
            Bank Statements
          </MDTypography>

          {alert && (
            <MDSnackbar
              color={alert?.type === "success" ? "success" : "error"}
              icon="notifications"
              title={alert?.type === "success" ? "Success" : "Error"}
              content={alert?.message}
              dateTime=""
              autoHideDuration={3000}
              open={alert !== null}
              close={() => setAlert(null)}
            />
          )}

          <MDBox marginLeft={2} minHeight={300}>
            <StatementsToolbar
              applicationId={id}
              refreshStatements={fetchBankStatements}
              loadBanksFromServer={loadPlaidBanksFromServer}
              handleAccountRefresh={handleAccountRefresh}
              setSelectedBank={() => console.log("Bank selected.")}
              refreshAll={refreshAll}
              merchantId={partyId}
              showOcrTransactionsModal={showOcrTransactionsModal}
              setShowOcrTransactionsModal={setShowOcrTransactionsModal}
              renderOcrAccountSelection={renderOcrAccountSelection}
              onRunOcrTransactions={handleRunOcrTransactions}
              ocrAccounts={ocrAccounts}
              isFunderNewFlow={true}
              plaidBanks={plaidBanks}
              plaidApiError={plaidApiError}
              setPlaidApiError={setPlaidApiError}
              flinksBanks={flinksBanks}
              flinksApiError={flinksApiError}
              setFlinksApiError={setFlinksApiError}
            />
            {renderAccounts()}
          </MDBox>
        </Card>
      </MDBox>

      <CustomModal
        open={showPlaidTransactionPullPopUp}
        onClose={handleClose}
        title={<MDTypography variant={"h4"}>{selectedAccountForPull?.accountnumber}</MDTypography>}
        cancelText="Cancel"
        submitText="Submit"
        onCancel={handleClose}
        onSubmit={handleSubmitAccountPull}
        maxWidth="sm"
        fullWidth={true}
      >
        <MDBox display="flex" flexDirection="column" width="100%">
          <MDTypography>Enter the Number of Days to Pull Transactions</MDTypography>
          <MDInput
            type="number"
            value={numberOfDays}
            onChange={handleNumberOfDaysChange}
            placeholder="Number of Days"
          />
        </MDBox>
      </CustomModal>

      <Card mb={3} minHeight={300}>
        <Card>{renderTransactions()}</Card>
      </Card>
    </>
  );
}

export default withDommer(BankStatementTab);